export class DownloadAttachmentRequest {
    RequestID?: number;
    BatchID?: number;
    FileName?: string;
    AllFiles?: boolean;
}

export default DownloadAttachmentRequest;